
/**
 * @description Create a hash of a strings contents.
 * @param {string} str  String content to be hashed
 * @returns {string}
 */
function contentHash(str) {
  let hash = 0;
  let i;
  let chr;

  if (str.length === 0) return hash;
  /* eslint-disable no-bitwise */
  for (i = 0; i < str.length; i += 1) {
    chr = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0;
  }
  /* eslint-enable no-bitwise */
  return hash.toString();
}

module.exports = contentHash;

export default contentHash;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/content-hash.js